const contentStatic = {
  // date formats;
  // not all are specified here, just the reusable ones;
  dateFormatComputer: `YYYY-MM-DD`,
  dateFormatHumanLong: `MMM D, YYYY`,
  dateFormatHumanShort: `ddd M/D`,
  dateFormatRangeLong: `M/D/YYYY`,
  dateFormatRangeShort: `M/D`,

  // Ajax forced delays;
  // this allows the user to see the flow as opposed to the pages swapping faster than the eye can track;
  // increase the delay as the user gets closer to the form, makes the content feel more important;
  delayForm: 1000,
  delayDetail: 750,
  delayList: 500,

  days: days(),
  objectTypes: objectTypes(),
  podStatuses: podStatuses(),
  podElementFields: podElementFields(),
  timeSlots: timeSlots(),

  // define how many records to show per page in the List components;
  podResultsPerPage: 20,
  spotResultsPerPage: 20,
  campaignResultsPerPage: 20,
  changeLogResultsPerPage: 20,
  inviteResultsPerPage: 20,
  reportsResultsPerPage: 20,
  ruleResultsPerPage: 20,
  daysPerTimeSlotPerPage: 14,
  userResultsPerPage: 20,

  // Pod Form default values;
  podFormDefaultSourceFile: `<i class="fa fa-cloud-upload"></i> Drop MP4 or QuickTime file to attach, or <a>browse</a>.`,
  podFormMaxFilesize: 2048, // MB
  podFormMinDuration: 64.1,
  podFormMaxDuration: 65.5,
  // Spot Form default values;
  spotFormDefaultSourceFile: `<i class="fa fa-cloud-upload"></i> Drop MP4, QuickTime or MXF file to attach, or <a>browse</a>.`,
  spotFormMaxFilesize: 2048, // MB

  // no results display messages;
  zeroPodsMessage: `No pods to display.`,
  zeroSpotsMessage: `No spots to display.`,
  zeroCampaignsMessage: `No campaigns to display.`,
  zeroLogsMessage: `No change log to display.`,
  zeroReportsMessage: `No reports to display.`,
  zeroRulesMessage: `No rules to display.`,
  zeroExceptionsMessage: `No exceptions to display.`,
  zeroInvitesMessage: `No invites to display.`,
  zeroUsersMessage: `No users to display.`,
  zeroStationsMessage: `You are not associated with any stations`
};

export default contentStatic;

//

// transform Django content types into a more readable URL;
function objectTypes() {
  return [
    {
      key: `rules.ruleexception`,
      path: `exception`
    },
    {
      key: `rules.rule`,
      path: `rule`
    },
    {
      key: `pods.pod`,
      path: `pod`
    },
    {
      key: `campaigns.campaign`,
      path: `campaign`
    },
    {
      key: `users.user`,
      path: `user`
    }
  ];
}

// return an array of days in display order;
function days() {
  return [
    {
      label: `Sunday`,
      value: 6
    },
    {
      label: `Monday`,
      value: 0
    },
    {
      label: `Tuesday`,
      value: 1
    },
    {
      label: `Wednesday`,
      value: 2
    },
    {
      label: `Thursday`,
      value: 3
    },
    {
      label: `Friday`,
      value: 4
    },
    {
      label: `Saturday`,
      value: 5
    }
  ];
}

// return an array of pod statuses;
function podStatuses() {
  return [
    {
      label: `All`,
      value: 0
    },
    {
      label: `Processing`,
      value: 1
    },
    {
      label: `Ready`,
      value: 2
    },
    {
      label: `Failed`,
      value: 3
    }
  ];
}

// return an array of pod element fields;
// including here the Campaign and the Rule options;
// because the Reporting part could be changed;
// so, no point in creating a separate list for this now;
function podElementFields() {
  return [
    {
      label: `Pod`,
      value: `pod_name`
    },
    {
      label: `Campaign`,
      value: `campaign_name`
    },
    {
      label: `Rule`,
      value: `rule_name`
    },
    {
      label: `Element ID`,
      value: `element_ids`
    },
    {
      label: `Protrack ID`,
      value: `protrack_ids`
    },
    {
      label: `Client Name`,
      value: `client_names`
    },
    {
      label: `Spot Name`,
      value: `spot_names`
    },
    {
      label: `Tape`,
      value: `tapes`
    },
    {
      label: `Order`,
      value: `orders`
    }
  ];
}

// possible values for the rule time slot field;
function timeSlots() {
  const timeslots = [];

  for (let i = 0; i <= 23; i = i + 1) {
    const prefix = i < 10 ? `0` : ``;
    const timeString28 = `${prefix}${i}:28`;
    const timeString58 = `${prefix}${i}:58`;

    timeslots.push(timeString28);
    timeslots.push(timeString58);
  }

  return timeslots;
}
